type GraphQLErrorLike = {
  message?: unknown;
};

type ApolloErrorLike = {
  graphQLErrors?: unknown;
};

export const hasCompleteCredentialEmailTarget = ({
  adminConsoleLoginEmail,
  chamberMemberId,
}: {
  adminConsoleLoginEmail?: string | null;
  chamberMemberId?: string | null;
}): boolean =>
  Boolean(adminConsoleLoginEmail?.trim() && chamberMemberId?.trim());

export const getCredentialEmailErrorMessage = ({
  error,
  fallbackMessage,
}: {
  error: unknown;
  fallbackMessage: string;
}): string => {
  if (!error || typeof error !== "object") {
    return fallbackMessage;
  }

  const graphQLErrors = (error as ApolloErrorLike).graphQLErrors;
  if (!Array.isArray(graphQLErrors)) {
    return fallbackMessage;
  }

  const firstMessage = graphQLErrors.find(
    (graphQLError): graphQLError is GraphQLErrorLike =>
      Boolean(
        graphQLError &&
          typeof graphQLError === "object" &&
          typeof (graphQLError as GraphQLErrorLike).message === "string" &&
          (graphQLError as { message: string }).message.trim()
      )
  )?.message;

  return typeof firstMessage === "string" && firstMessage.trim()
    ? firstMessage.trim()
    : fallbackMessage;
};
